import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { DetailPluginLock } from '@/presentation/pages/detail/basic/interface_lock/DetailPluginLock';
import _ from 'lodash';
import '@patsnap-ui/icon/assets/solid/SortLetterAToZ.svg';
import '@patsnap-ui/icon/assets/solid/SortLetterZToA.svg';
import '@patsnap-ui/icon/assets/solid/SortNumber1To9.svg';
import '@patsnap-ui/icon/assets/solid/SortNumber9To1.svg';
import '@patsnap-ui/icon/assets/solid/SortTimeLatestToOldest.svg';
import '@patsnap-ui/icon/assets/solid/SortTimeOldestToLatest.svg';
import '@patsnap-ui/icon/assets/solid/info.svg';
export const SortServiceSymbol = Symbol.for('SortService');
export var SORT_TYPE;
(function (SORT_TYPE) {
    SORT_TYPE["NUMBER"] = "number";
    SORT_TYPE["STRING"] = "string";
    SORT_TYPE["DATE"] = "date";
})(SORT_TYPE || (SORT_TYPE = {}));
const sortIconTypeMap = {
    [SORT_TYPE.NUMBER]: ['SolidSortNumber1To9', 'SolidSortNumber9To1'],
    [SORT_TYPE.STRING]: ['SolidSortLetterAToZ', 'SolidSortLetterZToA'],
    [SORT_TYPE.DATE]: ['SolidSortTimeOldestToLatest', 'SolidSortTimeLatestToOldest'],
};
function getSortIconByType(type) {
    const arr = sortIconTypeMap[type];
    if (!arr) {
        console.error(`sortIconTypeMap has no type ${type}`);
    }
    return arr || sortIconTypeMap[SORT_TYPE.STRING];
}
const sortIconMap = {};
export function getSortIconByKey(key) {
    return sortIconMap[key];
}
export function setSortIconByKey(key, value) {
    sortIconMap[key] = value;
}
class DataSortService {
    constructor({ sortList, fieldKeySortMap, }) {
        this.sortKey = '';
        this.sortList = [];
        this.fieldKeySortMap = {};
        this.sortKey = '';
        this.sortList = sortList;
        this.fieldKeySortMap = fieldKeySortMap;
    }
    getSortOptionsByField(key) {
        return this.fieldKeySortMap[key];
    }
}
let SortService = class SortService {
    constructor() {
        this.instance = new Map();
    }
    init() {
        const defaultItemsPlugins = DetailPluginLock.getAllPluginsSorted();
        _.forEach(defaultItemsPlugins, ({ name, fieldsAndSortsInfo }) => {
            // 文献特殊处理
            if (name === DetailPluginLock.KNOWN_PLUGIN_NAMES.PAPER) {
                setSortIconByKey('pdasc', sortIconTypeMap[SORT_TYPE.DATE][0]);
                setSortIconByKey('pddesc', sortIconTypeMap[SORT_TYPE.DATE][1]);
                setSortIconByKey('ccasc', sortIconTypeMap[SORT_TYPE.NUMBER][0]);
                setSortIconByKey('ccdesc', sortIconTypeMap[SORT_TYPE.NUMBER][1]);
                setSortIconByKey('wtasc', sortIconTypeMap[SORT_TYPE.DATE][0]);
                setSortIconByKey('wtdesc', sortIconTypeMap[SORT_TYPE.DATE][1]);
                this.instance.set(name, new DataSortService({
                    sortList: [
                        { key: 'pdasc' }, // 发表时间 旧-新
                        { key: 'pddesc' }, // 发表时间 新-旧
                        { key: 'ccasc' }, // 引用次数 升序
                        { key: 'ccdesc' }, // 引用次数 降序
                        { key: 'wtasc' }, // 收录时间 旧-新
                        { key: 'wtdesc' }, // 收录时间 新-旧
                    ],
                    fieldKeySortMap: {
                        PUBLISH_TIME: [
                            { sortKey: 'pdasc', index: 0 },
                            { sortKey: 'pddesc', index: 1 },
                        ], // 发表时间
                        CITATION_COUNT: [
                            { sortKey: 'ccasc', index: 0 },
                            { sortKey: 'ccdesc', index: 1 },
                        ], // 引用次数
                    },
                }));
                return;
            }
            if (!fieldsAndSortsInfo) {
                return;
            }
            const sortTypes = fieldsAndSortsInfo.sort_types;
            if (sortTypes) {
                const sortList = [];
                const fieldKeySortMap = {};
                _.forEach(sortTypes, ({ name, field, sort, type = SORT_TYPE.STRING }) => {
                    const index = ['asc', 'desc'].indexOf(sort);
                    setSortIconByKey(name, getSortIconByType(type)[index]);
                    sortList.push({ key: name });
                    if (!fieldKeySortMap[field]) {
                        fieldKeySortMap[field] = [];
                    }
                    fieldKeySortMap[field].push({
                        sortKey: name,
                        index,
                    });
                });
                this.instance.set(name, new DataSortService({
                    sortList,
                    fieldKeySortMap,
                }));
            }
        });
    }
    getInstance(name) {
        return this.instance.get(name);
    }
};
SortService = __decorate([
    injectable()
], SortService);
export { SortService };
